import api from "@/api.js";

export default {
  state: {
    currentStatus: {},
    statusRequestLoading: false,
    currentCommand: {},
    commandLoading: false,
    calibrated: false,
    calibrationLoading: false,
    platformPosition: "Raised",
    platformPositionLoading: false,
    currentPHPID: null,
    currentScanStartTime: null,
    over20MinutesWarning: false,
    scanStopped: false
  },
  mutations: {
    setCurrentStatus(state, payload) {
      state.currentStatus = payload;
    },
    setStatusRequestLoading(state, payload) {
      state.statusRequestLoading = payload;
    },
    setCurrentCommand(state, payload) {
      state.currentCommand = payload;
    },
    setCommandLoading(state, payload) {
      state.commandLoading = payload;
    },
    setCalibrated(state, payload) {
      state.calibrated = payload;
    },
    setCalibrationLoading(state, payload) {
      state.calibrationLoading = payload;
    },
    setPlatformPosition(state, payload) {
      state.platformPosition = payload;
    },
    setPlatformPositionLoading(state, payload) {
      state.platformPositionLoading = payload;
    },
    setCurrentPHPID(state, payload) {
      state.currentPHPID = payload;
    },
    setCurrentScanStartTime(state, payload) {
      state.currentScanStartTime = payload;
    },
    setOver20MinuteWarning(state, payload) {
      state.over20MinutesWarning = payload;
    },
    setScanStopped(state, payload) {
      state.scanStopped = payload;
    }
  },
  actions: {
    async deviceStatusRequest({ commit, dispatch, state }) {
      if (!state.statusRequestLoading) {
        commit("setStatusRequestLoading", true);
        commit("setCurrentCommand", "StatusRequest");
        let command = await api.post("device/StatusRequest", {});
        commit("setCurrentStatus", command.data.Response);
        commit("setStatusRequestLoading", false);
      }
      dispatch("checkScanDuration");
    },
    async runDeviceCommand({ commit }, options) {
      try {
        commit("setCommandLoading", true);
        commit("setCurrentCommand", options.command);
        let command = await api.post(options.ep, options.payload);
        commit("setCurrentStatus", command.data.Response);
        if (command.data.Response.phpID) {
          commit("setCurrentPHPID", command.data.Response.phpID);
        }
        commit("setCommandLoading", false);
        return "Success";
      } catch (error) {
        return "Error";
      }
    },
    async setDeviceScanStartTime({ commit }) {
      commit("setCurrentScanStartTime", Date.now());
    },
    async resetDeviceScanStartTime({ commit }) {
      commit("setCurrentScanStartTime", null);
    },
    async checkScanDuration({ commit, state }) {
      // console.log((Date.now() - state.currentScanStartTime) / 1000 / 60);
      if (
        (Date.now() - state.currentScanStartTime) / 1000 / 60 > 20 &&
        state.currentScanStartTime != null
      ) {
        commit("setOver20MinuteWarning", true);
      } else {
        commit("setOver20MinuteWarning", false);
      }
    },
    async calibrateDevice({ commit }) {
      let returnData = null;
      commit("setCalibrationLoading", true);
      commit("setCurrentCommand", "Calibrate");
      await api
        .post("device/Calibrate", {}, { timeout: 60000 })
        .then(response => {
          commit("setCalibrated", true);
          commit(
            "setPlatformPosition",
            response.data.Response.StrStatusPlatformPosition
          );
          commit("setCurrentStatus", response.data.Response);
          returnData = response;
        })
        .catch(err => {
          returnData = false;
        });
      commit("setCalibrationLoading", false);
      return returnData;
    },
    async changePlatformPosition({ commit }, position) {
      try {
        commit("setPlatformPositionLoading", true);
        commit("setCurrentCommand", "MoveTransmissionLines");
        let response = await api.post("device/ChangePlatformPosition", {
          position: position
        });
        commit(
          "setPlatformPosition",
          response.data.Response.StrStatusPlatformPosition
        );
        commit("setPlatformPositionLoading", false);
        commit("setCurrentStatus", response.data.Response);

        return response;
      } catch (error) {
        return "Error";
      }
    },
    async scanStoppedExternal({ commit }, payload) {
      commit("setScanStopped", payload);
    }
  },
  getters: {
    currentStatus(state) {
      return state.currentStatus;
    },
    currentCommand(state) {
      return state.currentCommand;
    },
    commandLoading(state) {
      return state.commandLoading;
    },
    calibrated(state) {
      return state.calibrated;
    },
    calibrationLoading(state) {
      return state.calibrationLoading;
    },
    platformPosition(state) {
      return state.platformPosition;
    },
    currentPHPID(state) {
      return state.currentPHPID;
    },
    over20MinutesWarning(state) {
      return state.over20MinutesWarning;
    },
    currentScanStartTime(state) {
      return state.currentScanStartTime;
    },
    scanStopped(state) {
      return state.scanStopped;
    }
  }
};
